import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { LanguageProvider, useLanguage } from "@/i18n";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Bots from "@/components/Bots";
import Products from "@/components/Products";
import Memorial from "@/components/Memorial";
import { MEMORIAL_UNTIL } from "@/data";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const TitleSync = () => {
  const { t } = useLanguage();
  useEffect(() => {
    document.title = `NavX Tecnologia — ${t.hero.line1} ${t.hero.line3}`;
  }, [t]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const el = document.querySelector(anchor.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -64 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <LanguageProvider>
      <TitleSync />
      <div data-testid="navx-app" className="min-h-screen overflow-x-clip bg-[#050714] text-slate-100 antialiased">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Manifesto />
          <Bots />
          <Products />
          {Date.now() < new Date(MEMORIAL_UNTIL).getTime() && <Memorial />}
          <Contact />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
